export default "__VITE_ASSET__wi7fn2ni__"